import { render, staticRenderFns } from "./SectionsBottom.vue?vue&type=template&id=a4eeae10"
import script from "./SectionsBottom.vue?vue&type=script&lang=js"
export * from "./SectionsBottom.vue?vue&type=script&lang=js"
import style0 from "./SectionsBottom.vue?vue&type=style&index=0&id=a4eeae10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports